module.exports = __webpack_public_path__ + "static/media/connector_plugged_in.199beefd.png";